export default __webpack_public_path__ + "static/media/covetrus-logo.05f42f8d.png";